import { makeStyles } from "@material-ui/core";

export const linkedTicketDialogStyles = makeStyles(() => ({
    loading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 240,
    },
}));
